<template>
  <div class="home">
    <div class="container">
      <HeaderLetter />
      <div class="row bg_ffffff">
        <div class="col-sm-12 padding_0">
          <img src="@/assets/images/SampleInvitationLetter.jpg" width="100%" height="100%" />
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
// CSS
import "@/assets/maincss/bootstrap.min.css";
import "@/assets/maincss/animate.css";
import "@/assets/maincss/fontface.css";
import "@/assets/css/font.css";
import "@/assets/maincss/custom.css";
import "@/assets/css/spacing.css";

// Component
import HeaderLetter from "@/components/headerLetter.vue";
import Footer from "@/components/footer.vue";

export default {
  name: "Home",
  components: {
    HeaderLetter,
    Footer,
  },
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}
.bg_dark_blue {
  background-color: #102f50;
}
.text-secondary {
  border-top: 1px solid #bfc6cc !important;
}
.catgory-input {
  position: absolute !important;
  right: 0 !important;
  padding-right: 5% !important;
}
.pt-3 {
  padding-top: 1.5rem !important;
}
.pb-3 {
  padding-bottom: 1.5rem !important;
}
.d-none {
  display: none !important;
}

.pl-2 {
  padding-left: 1rem !important;
}
.pr-2 {
  padding-right: 1rem !important;
}
.pl-3 {
  padding-left: 1.5rem !important;
}
.pr-3 {
  padding-right: 1.5rem !important;
}
.pl-4 {
  padding-left: 2rem !important;
}
.pr-4 {
  padding-right: 2rem !important;
}
.goback {
  border: 1px solid black;
  color: black;
}
.home {
  background-color: #3c3c3b;
  font-family: Georgia, Times, serif;
}
.btn-app {
  color: #fff !important;
  background-color: #102f51 !important;
}
.btn-app:hover {
  color: #fff !important;
  background-color: #235a99 !important;
}

.filename {
  color: #337ab7;
  text-decoration: none;
  white-space: nowrap;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>